import { createFileRoute } from '@tanstack/react-router'
import { YnabImportScreen } from '@/features/import/YnabImportScreen'

export const Route = createFileRoute('/import')({
  component: YnabImportScreen,
})
